// DS9.12M
import React from 'react';
import classnames from 'classnames';
import Background from '@wix/da-shared-react/pkg/Background';
import UserAvatar from '@wix/da-shared-react/pkg/User/Avatar';
import UserLink from '@wix/da-shared-react/pkg/User/Link';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import JoinGroupButton from '@wix/da-shared-react/pkg/JoinGroupButton';

import MoreActionsDropdownMobile from '../ProfileIdentity/MoreActionsDropdown/Mobile';
import MonetizationPromoBanner from '../MonetizationPromoBanner';
import WatchButton from './WatchButton';
import NotesButton from './NotesButton';
import SkinButton from './SkinButton';
import {
  BackgroundImageDisplayMode,
  BackgroundType,
} from '@wix/da-shared-react/pkg/Background/types';
import { PapiDeviation, PapiUser } from '@wix/da-papi-types';
import ProfileStatItems from '../ProfileIdentity/ProfileStatItems';
import AvatarEdit from '../ProfileIdentity/AvatarEdit';

import s from './ProfileHeroMobile.scss';

export interface Props {
  className?: string;
  coverDeviation?: PapiDeviation;
  profileOwnerUser: PapiUser;
  isOwner: boolean;
  isGroup: boolean;
  stats: object;
  tagline?: string;
}

export const ProfileHeroMobile: React.FC<Props> = ({
  className,
  stats,
  tagline = '',
  coverDeviation,
  profileOwnerUser,
  isOwner,
  isGroup,
}) => {
  const isMobileSkins = useFlag('mobile_skins');
  const isMobileAvatarEdit = useFlag('avatar_edit_mobile');
  return (
    <div className={classnames(s['root'], className)}>
      <div className={s['hero-wrapper']}>
        {coverDeviation ? (
          <Background
            variant="hero"
            backgroundType={BackgroundType.IMAGE}
            imageDeviation={coverDeviation}
            imageDisplayMode={BackgroundImageDisplayMode.COVER}
            className={s['background']}
          />
        ) : (
          <div className={classnames(s['background'], s['no-image'])}>
            <div className={s['no-image-meteors']} />
          </div>
        )}
        <MonetizationPromoBanner className={s['tier-banner']} />
        {!isGroup && !(isOwner && isMobileSkins) && (
          <MoreActionsDropdownMobile className={s['more-menu']} />
        )}
      </div>
      <div className={s['avatar']}>
        <UserAvatar user={profileOwnerUser} size={100} />
        {isOwner && isMobileAvatarEdit && <AvatarEdit />}
      </div>
      <div className={s['hug']}>
        <div className={s['info-text']}>
          <div className={s['username-skin-button-wrapper']}>
            <UserLink className={s['username']} user={profileOwnerUser} />
            {isOwner && isMobileSkins && (
              <SkinButton className={s['skin-button']} />
            )}
          </div>
          <div className={s['tagline']}>{tagline}</div>
        </div>
        {!isGroup && !isOwner && (
          <div className={s['action-bar']}>
            <NotesButton user={profileOwnerUser} />
            <WatchButton user={profileOwnerUser} />
          </div>
        )}
        {isGroup && (
          <div className={s['group-action-bar']}>
            <JoinGroupButton
              type="solid"
              group={profileOwnerUser}
              className={s['cta-button']}
            />
            <MoreActionsDropdownMobile />
          </div>
        )}
        <div className={s['stats']}>
          <ProfileStatItems
            statsData={stats as any}
            defaultStats={['watchers', 'deviations', 'pageviews']}
            additionalStats={[]}
            itemClassName={s['stat-item']}
            countClassName={s['stat-item-count']}
          />
        </div>
      </div>
    </div>
  );
};
ProfileHeroMobile.displayName = 'ProfileHeroMobile';

export default ProfileHeroMobile;
